import { joinInfoMeta } from './joinMetaInfo.js';
import { parseData } from './parseData';
import { setFIDSpectrumData } from './setFIDSpectrumData';
import { setProcessedSpectrumData } from './setProcessedSpectrumData';

export async function convert1D(files, options) {
  const result = await parseData(files.procs, options);
  const acqus = await parseData(files.acqus, options);
  joinInfoMeta(result, acqus);

  if (files.quantFactorSample) addEreticFactor(result, files);

  if (files['1r'] || files['1i']) {
    await setProcessedSpectrumData(
      {
        re: files['1r'],
        im: files['1i'],
      },
      result,
    );
  } else if (files.fid) {
    await setFIDSpectrumData(files.fid, result);
  }

  return result;
}

async function addEreticFactor(result, files) {
  const quantFactorSample = (await files.quantFactorSample.text()).match(
    /<Application[\w\W]+<Eretic_Factor>(?<ereticFactor>[\d.]+)/,
  );
  if (quantFactorSample) {
    result.info.ereticFactor = Number(quantFactorSample.groups.ereticFactor);
  }
}
